// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueRouter from "vue-router"
import routes from './common/js/router';
import { get, post } from './request/http'
import App from './App'

Vue.use(VueRouter)

const router = new VueRouter({
  routes  
})

//Vue.prototype.$post=post;
//Vue.prototype.$get=get;

new Vue({
  el: '#app',
  components: { App },
  template: '<App/>',
  router,
//store
});



// WEBPACK FOOTER //
// ./src/main.js